import { useState, FormEvent } from "react";
import { users } from "../../fake-db/users";

const UpdateProfile = () => {
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const handleUpdateBio = (e: FormEvent) => {
    e.preventDefault();
    setIsEdit(false);
  };

  return (
    <div className="flex flex-col justify-center items-center w-full h-[220px]">
      <img
        src={users[0]?.avatar}
        alt={users[0]?.name}
        className="w-20 h-20 rounded-full object-cover object-center mb-3"
      />
      <h4 className="text-xl text-slate-600 font-medium">{users[0]?.name}</h4>
      <div className="flex gap-2 items-center">
        {!isEdit && (
          <p className="text-base text-gray-500">{users[0]?.profession}</p>
        )}

        {/* Edit Form */}
        {isEdit && (
          <form
            className="flex gap-2 items-center"
            onSubmit={(e) => handleUpdateBio(e)}
          >
            <input
              type={"text"}
              defaultValue={users[0]?.profession}
              className="resize-none border border-gray-300 outline-none rounded-md w-full py-2 px-3 text-slate-500 text-base flex-1"
            />
            <button type="submit" className="text-sm">
              <i className="fa-solid fa-floppy-disk text-violet-500"></i>
            </button>
          </form>
        )}

        {/* Edit Button */}
        {!isEdit && (
          <button className="text-sm" onClick={() => setIsEdit(!isEdit)}>
            <i className="fa-solid fa-pen-to-square text-violet-500"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default UpdateProfile;
